import * as React from 'react';
import styled from 'styled-components';
import { applicationEndpoints } from '../../../amorg-common/applicationEndpoints';
import { mediaQuery } from '../../../designSystem/BreakPoints';
import { Icon } from '../../../designSystem/icons/Icons';
import { Footer } from './elements/Footer';

export type PortalLayoutProps = React.PropsWithChildren<{
    navigation?: React.ReactNode,
}>

export const PortalLayout = ({ navigation, children }: PortalLayoutProps) => {

    const [menuOpen, setMenuOpen] = React.useState(false);

    return (
        <Main className="employeePortalPage">
            <PublicNavigation className="publicNavigation">
                <Wrapper className="publicNavigationWrapper">
                    <PublicLogo href={applicationEndpoints.portal}>
                        <img src="/images/amorg_logo_blue.svg" />
                    </PublicLogo>

                    {navigation &&
                        <>
                            <DesktopNav>
                                {navigation}
                            </DesktopNav>
                            
                            <BurgerButton onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
                                <Icon name={menuOpen ? 'actions_close' : 'navigation_menu'} size='medium' />
                            </BurgerButton>
                            <MobileMenu isOpen={menuOpen} onClick={() => setMenuOpen(false)}>
                                {navigation}
                            </MobileMenu>
                        </>
                    }
                </Wrapper>
            </PublicNavigation>
            <CoreContent className="mainContent">
                {children}
            </CoreContent>
            <CoreFooter>
                <Footer publicSupportUrl />
            </CoreFooter>
        </Main>
    );
};

const Main = styled.div`
    
    display:grid;
    min-height: 100%;
    grid-template-columns: auto;
    grid-template-rows: 60px auto min-content;
    grid-template-areas:
        "navigation"
        "content"
        "footer";

    ${mediaQuery.tablet} {
        grid-template-columns: auto;
        grid-template-rows: 80px auto min-content;
        grid-template-areas:
        "navigation"
        "content"
        "footer";
    }
`;

const CoreContent = styled.div`
    
    padding-bottom:20px;
    position: relative;
    z-index: 10;
    grid-area: content;
`;

const CoreFooter = styled.div`
    grid-area: footer;
`;

const PublicNavigation = styled.div`
    background: rgb(222, 215, 199);
    align-self: start;
    position: relative;
    height: 50px;
    width: 100%;
    margin:0 auto;
    box-shadow: 0px 8px 5px 0px rgba(0,0,0,0.25);
    -webkit-box-shadow: 0px 8px 5px 0px rgba(0,0,0,0.25);
    -moz-box-shadow: 0px 8px 5px 0px rgba(0,0,0,0.25);
    z-index:1000;
  
    ${mediaQuery.tablet} {
        height: 80px;
        width: 100%;
    }
`;


const Wrapper = styled.div`
    width:100%;
    margin: auto;
    max-width:90%;
    padding:16px 0px;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    display: flex;
    flex-direction: row;
    padding: 0 10px;
`;


const DesktopNav = styled.div`
    display: none;
    align-items: center;
    gap: 8px;

    ${mediaQuery.tablet} {
        display: flex;
    }
`;

const BurgerButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;

    ${mediaQuery.tablet} {
        display: none;
    }
`;

const MobileMenu = styled.div<{ isOpen: boolean }>`
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    background: rgb(222, 215, 199);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-height: ${props => props.isOpen ? '500px' : '0'};
    padding: ${props => props.isOpen ? '8px 16px 16px' : '0 16px'};
    box-shadow: 0px 8px 5px 0px rgba(0,0,0,0.25);
    z-index: 999;
    align-items: flex-start;
    transition: max-height 0.3s ease, padding 0.3s ease;

    ${mediaQuery.tablet} {
        display: none;
    }
`;

const PublicLogo = styled.a`
    display: flex;
    align-items: center;
    justify-content: start;
    height: 50%;
    width: 50%;

    & img {
        height: 100%;
        width: auto;
        max-width: 100%;
    }
`;
